import Action from './action';

interface IModalSingleton {
    text: string,
    show?: boolean,
    extraClass?: string,
}

const initialState = {
    text: '',
    show: false,
    extraClass: ''
};

export default (state = initialState, action: {type: string, playload: IModalSingleton}) => {
    switch (action.type) {
        case Action.UPDATE_GLOBAL_TOAST: {
            // 每次先用initialState重置数据
            return {
                ...initialState,
                ...action.playload
            }
        }
        case Action.UPDATE_GLOBAL_TOAST_ONLY: {
            // 不重置数据
            return {
                ...state,
                ...action.playload
            }
        }
        default: return state;
    }
}
